import TooltipIcon from '@images/icons/tooltip-icon.svg?react'
import UploadIcon from '@images/icons/upload-icon-blue.svg?react'
import FileUploadModal from '@withdrawals/components/FileUploadModal'
import { GlobalContext, tr } from 'mmfintech-commons'
import { useContext } from 'react'

import './fileUploadPane.scss'
import ReactTooltip from 'react-tooltip'

const FileUploadPane = () => {
  const { modalHide, modalShow }: any = useContext(GlobalContext)

  const handleOpenDocumentsModal = () => {
    modalShow({
      options: { closeOnClickOutside: false },
      get header() {
        return tr('FRONTEND.FILE_UPLOAD_PANE.SUPPORTING_DOCUMENT', 'Supporting document')
      },
      content: <FileUploadModal onHide={modalHide} />
    })
  }

  return (
    <div className='file-upload-pane-wrapper'>
      <div className='file-upload-pane-title'>
        <span>
          {tr('FRONTEND.WITHDRAW.BANK_TRANSFER.SUPPLEMENTAL_DOCUMENTS.UPLOAD.TITLE', 'Upload Supporting Documents')}
        </span>
        <div data-for={`tooltip-info`} data-tip={tr('FRONTEND.COMMON.UPLOAD_TOOLTIP', 'Upload tooltip')}>
          <TooltipIcon />
        </div>
        <ReactTooltip
          id='tooltip-info'
          effect='solid'
          className='custom-tool-tip-component file-upload-tooltip'
          noArrow
          place='bottom-end'
        >
          <div>
            <h6>
              {tr(
                'FRONTEND.WITHDRAW.BANK_TRANSFER.SUPPLEMENTAL_DOCUMENTS.UPLOAD.TOOLTIP_TITLE',
                'Upload a supporting document for your bank transfer.'
              )}
            </h6>
            <p>
              {tr(
                'FRONTEND.WITHDRAW.BANK_TRANSFER.SUPPLEMENTAL_DOCUMENTS.UPLOAD.TOOLTIP_TEXT',
                'This document is necessary to ensure compliance with financial regulations and to help prevent unauthorized or fraudulent transactions. Please ensure that the document accurately reflects the nature and details of the transfer.'
              )}
            </p>
          </div>
        </ReactTooltip>
      </div>
      <div className='file-upload-pane-files' onClick={handleOpenDocumentsModal} data-test='upload-files'>
        <UploadIcon />
        <div>
          {tr('FRONTEND.FILE_UPLOAD_PANE.UPLOAD_FILES', 'Upload Files')} <span className='asterisk'>*</span>
        </div>
      </div>
    </div>
  )
}

export default FileUploadPane
